/**
 * 갱신안내 팝업 "N일간 보지 않기" (기획서 5p)
 *
 * 기간은 파르나스 확정 전이라 임시로 7일이다. 아래 상수만 바꾸면 된다.
 *
 * 저장은 localStorage 를 쓴다. 서버에 둘 만한 값이 아니고, 기기별로 판단하면 충분하다.
 * 회원 단위로 키를 나누는 이유는 한 기기에서 다른 계정으로 로그인했을 때
 * 앞사람의 "보지 않기"를 물려받지 않게 하기 위해서다.
 */

// todo 파르나스 확정 후 조정 (기획서 5p 코멘트)
export const NOTICE_HIDE_DAYS = 7

const KEY_PREFIX = "renewal_notice_hidden_until"

function storageKey(memberId) {
    return memberId ? `${KEY_PREFIX}:${memberId}` : KEY_PREFIX
}

/**
 * 지금 팝업을 감춰야 하는지
 *
 * @param {Number|String} memberId memberMetaId
 * @returns {Boolean}
 */
export function isNoticeHidden(memberId) {
    try {
        const until = Number(localStorage.getItem(storageKey(memberId)))
        if (!until) return false

        // 만료됐으면 흔적을 지워 두어 키가 쌓이지 않게 한다.
        if (Date.now() >= until) {
            localStorage.removeItem(storageKey(memberId))
            return false
        }
        return true
    } catch (e) {
        // 시크릿 모드 등으로 localStorage 를 쓸 수 없으면 그냥 노출한다.
        return false
    }
}

/**
 * 오늘부터 NOTICE_HIDE_DAYS 일간 감춘다.
 *
 * @param {Number|String} memberId memberMetaId
 */
export function hideNoticeFor(memberId) {
    try {
        const until = Date.now() + NOTICE_HIDE_DAYS * 24 * 60 * 60 * 1000
        localStorage.setItem(storageKey(memberId), String(until))
    } catch (e) {
        // 저장하지 못해도 기능이 막히지는 않는다. 다음에 또 뜰 뿐이다.
    }
}

/**
 * 갱신 결제 직후 표시 — 홈이 멤버십 동기화를 기다리게 한다. (2026-09-28)
 *
 * 새로 발급된 멤버십은 홈의 CMS 동기화(`/members/membership-update`)로만 우리 DB 에 들어온다.
 * 홈은 평소 동기화를 기다리지 않고 목록을 조회하므로, 결제 직후에는 이전 멤버십이 보인다.
 *
 * 결제 완료 화면에서 표시를 남기고 홈이 한 번 꺼내 쓴다. 버튼·뒤로가기·헤더 등
 * 어느 길로 홈에 가든 잡히도록 이동 시점이 아니라 완료 화면 진입 시점에 남긴다.
 * sessionStorage 라 앱을 다시 켜면 사라진다 — 그때는 어차피 동기화가 끝나 있다.
 */
const RENEWAL_PAID_KEY = "renewal_paid"

export function markRenewalPaid() {
    try {
        sessionStorage.setItem(RENEWAL_PAID_KEY, "1")
    } catch (e) {
        // 저장하지 못하면 홈이 예전처럼 동작할 뿐이다.
    }
}

/** 표시가 있었는지. 꺼내면 지운다(1회성). */
export function takeRenewalPaid() {
    try {
        const paid = sessionStorage.getItem(RENEWAL_PAID_KEY) === "1"
        sessionStorage.removeItem(RENEWAL_PAID_KEY)
        return paid
    } catch (e) {
        return false
    }
}
